import { c as _c } from "react/compiler-runtime";
import { createFileRoute } from '@tanstack/react-router';
import { useContext } from 'react';
import z from 'zod';
import { useStore } from 'zustand';
import { LoadingFallback } from '@/idv2/components/loading-fallback';
import { CompletionScreen } from '@/idv2/features/complete';
import { getIdv2StoreData, setIdv2StoreData } from '@/idv2/features/idv-to-idv2';
import { type IDV2Store, StoreContext } from '@/idv2/features/idv-to-idv2/idv2-provider';
import { getLogger } from '@/idv2/utils/logger';
import nid from '@/idv2/utils/neuro-id';
const completeSearchSchema = z.object({
  validationToken: z.string()
});
const {
  logInfo
} = getLogger({
  name: 'idv2',
  location: 'complete-route'
});
export const Route = createFileRoute('/complete')({
  beforeLoad: async ({
    context: {
      onComplete
    },
    search
  }) => {
    logInfo('Complete flow complete route started');
    const validationToken = search.validationToken;
    nid.complete();
    const hasCompletionScreen = !!getIdv2StoreData()?.completionPage;
    setIdv2StoreData({
      canGoBack: false
    });
    onComplete(validationToken, {
      hasCompletionScreen
    });
  },
  validateSearch: completeSearchSchema,
  component: CompletePage
});
function CompletePage() {
  const $ = _c(4);
  const {
    validationToken
  } = Route.useSearch();
  const store = useContext(StoreContext);
  const autoAdvance = useStore(store, _temp);
  const page = getIdv2StoreData()?.completionPage;
  if (!page) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <LoadingFallback />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== autoAdvance || $[2] !== validationToken) {
    t0 = <CompletionScreen page={page} validationToken={validationToken} autoAdvance={autoAdvance} />;
    $[1] = autoAdvance;
    $[2] = validationToken;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
function _temp(state) {
  return state.autoAdvance;
}